import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NiceModal from '@ebay/nice-modal-react';
import { getLevelNodeEnrollment } from 'services/api';
import { getProfileInfo } from 'services/utils';
import ModalEnrollmentClosure from 'pctComponents/modals/ModalEnrollmentClosure';

const CLOSED_STATUSES = ['COMPLETED', 'PASSED', 'FAILED'];

const getIdEnrollmentFromPath = (pathname: string): string | null => {
    const parts = pathname.split('/').filter(Boolean);
    const route = parts[0];

    switch (route) {
        case 'level':
        case 'lms':
        case 'lessons':
        case 'evaluations':
            return parts[1] || null;
        case 'contentNode':
            return parts[3] || null;
        default:
            return null;
    }
};

const useEnrollmentClosureModal = () => {
    const location = useLocation();

    useEffect(() => {
        const idEnrollment = getIdEnrollmentFromPath(location.pathname);
        if (!idEnrollment) return;

        const shownKey = `enrollmentClosureShown_${idEnrollment}`;
        if (localStorage.getItem(shownKey)) return;

        const idUser = getProfileInfo()?.idUser;
        if (!idUser) return;

        getLevelNodeEnrollment(idUser, String(idEnrollment), null)
            .then((response) => {
                const nodeData = response?.data?.node;
                const nodeEnrollment = nodeData?.nodeEnrollment;
                const enrollment = nodeEnrollment?.enrollment;
                const status = enrollment?.status;

                if (!CLOSED_STATUSES.includes(status)) return;
                if (localStorage.getItem(shownKey)) return;
                localStorage.setItem(shownKey, 'true');

                const team = nodeEnrollment?.team;
                const teamExpired = team?.finalDate ? Date.now() > new Date(team.finalDate).getTime() : false;
                const allowTeamReenrollment = Boolean(team?.allowReenrollment) && !teamExpired;
                const hasTeamAvailable = Boolean(nodeData?.hasTeamAvailable);
                const selfEnrollment = Boolean(nodeData?.selfEnrollment);
                const canReenroll = allowTeamReenrollment || hasTeamAvailable || selfEnrollment;

                NiceModal.show(ModalEnrollmentClosure, {
                    obj: {
                        variant: status,
                        trainingName: nodeData?.title || '',
                        finalGrade: enrollment?.grade ?? nodeEnrollment?.grade ?? null,
                        masteryScore: nodeData?.masteryScore ?? null,
                        idUser,
                        idEnrollment: enrollment?.idEnrollment ?? idEnrollment,
                        idNodeEnrollment: nodeEnrollment?.idNodeEnrollment,
                        hasCertificate: Boolean(team?.idCertificate),
                        canReenroll,
                        nodeCode: nodeData?.nodeCode,
                        idTeam: team?.idTeam,
                        allowTeamReenrollment,
                        hasTeamAvailable,
                        selfEnrollment,
                        nodeData,
                    },
                });
            })
            .catch(() => null);
    }, [location.pathname]);
};

export default useEnrollmentClosureModal;
